import React from 'react'
import cn from 'classnames'

import { useTranslation } from 'react-i18next'

import { SideBarNav, Icon, NavButton } from '../../../components'

export const AdminNav = () => {

    const { t } = useTranslation();

    return (
        <SideBarNav>
            <NavButton className="mb-2" to="/patients" text={t('patients')} icon="ClinicalHistory" />
            <NavButton className="mb-2" to="/users" text={t('users')} icon="Users" />
            <NavButton className="mb-2" to="/institutions" text={t('institutions')} icon="Hospital" />
            {/* <NavButton to="/notifications" disabled text={t('notifications')} icon="Notifications" />
            <NavButton to="/settings" disabled text={t('settings')} icon="Settings" /> */}
        </SideBarNav >
    )
}
